// components/shared/Toast.jss
import { toast } from 'react-toastify';

const toastConfig = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
};

class ToastManager {
  constructor() {
    this.currentToast = null;
    this.lastMessage = '';
    this.lastType = '';
    this.timeoutId = null;
  }

  showToast(message, type) {
    // If the same message and type is being shown, don't show it again
    if (message === this.lastMessage && type === this.lastType) {
      return;
    }

    // Dismiss any existing toast
    if (this.currentToast) {
      toast.dismiss(this.currentToast);
    }

    // Clear any existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Show new toast
    this.currentToast = toast[type](message, toastConfig);
    this.lastMessage = message;
    this.lastType = type;

    // Reset last message after toast duration
    this.timeoutId = setTimeout(() => {
      this.lastMessage = '';
      this.lastType = '';
      this.currentToast = null;
    }, toastConfig.autoClose);
  }
}

const toastManager = new ToastManager();

const Toast = {
  success: (message) => {
    toastManager.showToast(message, 'success');
  },
  error: (message) => {
    toastManager.showToast(message, 'error');
  },
  info: (message) => {
    toastManager.showToast(message, 'info');
  },
  warning: (message) => {
    toastManager.showToast(message, 'warning');
  }
};

export default Toast;
